import { InputField } from "../common/InputField";
import { SelectField } from "../common/SelectField";

export const DynamicField = ({
  label,
  type,
  value,
  placeholder,
  options,
  defaultValue,
  onChange,disabled
}) => {
  if (type === "select") {
    return (
      <SelectField
        label={label}
        options={options}
        value={value || ""}
        onChange={onChange}
        disabled={disabled}
      />
    );
  }

  return (
    <InputField
      label={label}
      type={type}
      placeholder={placeholder}
      value={value || ""}
      onChange={onChange}
      disabled={disabled}
    />
  );
};
